import request from '@/utils/request';
/**获取列表数据 */
export function intermediaryList(data) {
  return request.post('admin/intermediary/resource', data);
}
export function intermediaryTree(data) {
  return request.post('admin/intermediary/tree', data);
}
export function intermediaryList2(data) {
  return request.post('admin/intermediary/list', data);
}
export function addIntermediary(data) {
  return request.post('admin/intermediary/store', data);
}
export function editIntermediary(data) {
  return request.post('admin/intermediary/edit', data);
}
export function delIntermediary(data) {
  return request.post('admin/intermediary/delete', data);
}
export function intermediarystatus(data) {
  return request.post('admin/intermediary/status', data);
}
export function intermediaryResource(data) {
  return request.post('admin/intermediary/resource', data);
}
/**图片上传 */
export const uploadFile = process.env.VUE_APP_BASE_API + 'upload/file';